export const VACANCY = 1;
export const SAS_TRAINING = 2;
